window.addEventListener('load', function() {
    var isHome = document.getElementById('home') ? true : false
	var footerButtons = document.getElementById('footer-buttons'),
		stickyHeader = new Waypoint({
			element: hero.querySelector('.title'),
			handler: function(direction) {
				var down = direction == 'down';

				if(down)
					body.classList.add('sticky');
				else
					body.classList.remove('sticky');

				if(footerButtons)
					Velocity(footerButtons, {opacity: down ? [1,0] : [0,1]}, {duration: 300, display: down ? 'flex' : 'none'});
			},
			offset: isHome ? header.offsetHeight : header.offsetHeight
		});
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});
